import React from "react";
import XLSX from "sheetjs-style";
import * as FileSaver from "file-saver";
import { ExcelIcon } from "../../util/excelIcon";

export const ExportExcel = ({ excelData, fileName }) => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spredsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const exportExcel = async () => {
    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  return (
    <button onClick={(e) => exportExcel(fileName)}>
      <ExcelIcon size={32} color="#803333" weight="bold" />{" "}
    </button>
  );
};
